import { render, staticRenderFns } from "./Chi_chineseNewYearSection.vue?vue&type=template&id=b72d6866&scoped=true"
import script from "./Chi_chineseNewYearSection.vue?vue&type=script&lang=ts"
export * from "./Chi_chineseNewYearSection.vue?vue&type=script&lang=ts"
import style0 from "./Chi_chineseNewYearSection.vue?vue&type=style&index=0&id=b72d6866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d6866",
  null
  
)

export default component.exports